var window=global;var $CLJS=require("./cljs_env");require("./goog.base.js");
$CLJS.QA=require("ttag");module.exports=$CLJS.QA;